import React from "react";
import { motion } from "framer-motion";

import { TbBrandJavascript, TbBrandCss3, TbBrandPython } from "react-icons/tb";
import { FaReact, FaNodeJs } from "react-icons/fa";

function Skills() {
  const communicationProgress = 80;
  const teamWork = 90;
  const projectManagement = 85;
  const creativity = 90;
  return (
    <div className="flex flex-col md:flex-row w-full justify-around gap-8 md:gap-16">
      <div className="flex gap-8 md:gap-12 flex-col w-full  justify-center items-center">
        <div className="section__contentSubTitle ">Technical Skills</div>
        <div className="flex  w-full flex-col gap-4 justify-center items-center font-medium">
          {/* bar 1 */}
          <div className="flex flex-col gap-1 w-full  about__content ">
            {/* heading of bar */}
            <div className="flex justify-between items-end pb-2">
              <div className="flex gap-2 justify-center items-center">
                <span>JavaScript</span>
                <TbBrandJavascript className="text-lg text-yellow-400" />
              </div>

              <span> {95}%</span>
            </div>
            <div className="w-[100%] h-1 bg-leetcodeBorderColor rounded-lg">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${95}%` }}
                className=" h-1 bg-firstColor rounded-lg relative"
                transition={{ duration: 1.5, ease: "easeIn" }}
              ></motion.div>
            </div>
          </div>
          {/* bar 2 */}
          <div className="flex flex-col gap-1 w-full  about__content ">
            {/* heading of bar */}
            <div className="flex justify-between items-end pb-2">
              <div className="flex gap-2 justify-center items-center">
                <span>React JS</span>
                <FaReact className="text-lg text-blue-500" />
              </div>

              <span> {90}%</span>
            </div>
            <div className="w-[100%] h-1 bg-leetcodeBorderColor rounded-lg">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${90}%` }}
                className=" h-1 bg-firstColor rounded-lg relative"
                transition={{ duration: 1.5, ease: "easeIn" }}
              ></motion.div>
            </div>
          </div>
          {/* bar 3*/}
          <div className="flex flex-col gap-1 w-full  about__content ">
            {/* heading of bar */}
            <div className="flex justify-between items-end pb-2">
              <div className="flex gap-2 justify-center items-center">
                <span>Css3</span>
                <TbBrandCss3 className="text-lg text-blue-400" />
              </div>

              <span> {85}%</span>
            </div>
            <div className="w-[100%] h-1 bg-leetcodeBorderColor rounded-lg">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${85}%` }}
                className=" h-1 bg-firstColor  rounded-lg relative"
                transition={{ duration: 1.5, ease: "easeIn" }}
              ></motion.div>
            </div>
          </div>
          {/* bar 4*/}
          <div className="flex flex-col gap-1 w-full  about__content ">
            {/* heading of bar */}
            <div className="flex justify-between items-end pb-2">
              <div className="flex gap-2 justify-center items-center">
                <span>Node JS</span>
                <FaNodeJs className="text-lg text-green-500" />
              </div>

              <span> {60}%</span>
            </div>
            <div className="w-[100%] h-1 bg-leetcodeBorderColor rounded-lg">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${60}%` }}
                className=" h-1 bg-firstColor  rounded-lg relative"
                transition={{ duration: 1.5, ease: "easeIn" }}
              ></motion.div>
            </div>
          </div>
          {/* bar 5*/}
          <div className="flex flex-col gap-1 w-full  about__content ">
            {/* heading of bar */}
            <div className="flex justify-between items-end pb-2">
              <div className="flex gap-2 justify-center items-center">
                <span>Python</span>
                <TbBrandPython className="text-lg text-yellow-400" />
              </div>

              <span> {80}%</span>
            </div>
            <div className="w-[100%] h-1 bg-leetcodeBorderColor rounded-lg">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: `${80}%` }}
                className=" h-1 bg-firstColor  rounded-lg relative"
                transition={{ duration: 1.5, ease: "easeIn" }}
              ></motion.div>
            </div>
          </div>
        </div>
      </div>
      {/* professional skills */}
      <div className="flex flex-col w-full justify-start items-center font-medium gap-8 md:gap-12 ">
        <div className="section__contentSubTitle">Professional Skills</div>
        <div className="w-full grid grid-cols-2 gap-6">
          {/* round progress */}
          <div className="flex gap-2 flex-col items-center justify-center about__content">
            <motion.div
              initial={{
                background: `conic-gradient(
            hsl(250, 69%, 61%)${0}deg,
            hsla(250, 69%, 61%, 0.40) ${0}deg
            )`,
              }}
              animate={{
                background: `conic-gradient(
            hsl(250, 69%, 61%)${teamWork * 3.6}deg,
            hsla(250, 69%, 61%, 0.40) ${teamWork * 3.6}deg
            )`,
              }}
              transition={{ duration: 1.5, ease: "easeIn" }}
              className="w-[45%]  aspect-square rounded-full relative shadow-sm"
            >
              <div className="flex items-center flex-col  justify-center w-[93%]  about__content  bg-containerColor dark:bg-darkContainerColor aspect-square rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <span className="text-base md:text-xs lg:text-base font-semibold ">
                  {teamWork}%
                </span>
              </div>
            </motion.div>
            <div className="">Team Work</div>
          </div>
          {/* round progress team communication*/}
          <div className="flex gap-2 flex-col items-center justify-center about__content">
            <motion.div
              initial={{
                background: `conic-gradient(
            hsl(250, 69%, 61%)${0}deg,
            hsla(250, 69%, 61%, 0.40) ${0}deg
            )`,
              }}
              animate={{
                background: `conic-gradient(
            hsl(250, 69%, 61%)${communicationProgress * 3.6}deg,
            hsla(250, 69%, 61%, 0.40) ${communicationProgress * 3.6}deg
            )`,
              }}
              transition={{ duration: 1.5, ease: "easeIn" }}
              className="w-[45%]  aspect-square rounded-full relative shadow-sm"
            >
              <div className="flex items-center flex-col  justify-center w-[93%]  about__content  bg-containerColor dark:bg-darkContainerColor aspect-square rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <span className="text-base md:text-xs lg:text-base  font-semibold ">
                  {communicationProgress}%
                </span>
              </div>
            </motion.div>
            <div className="">Communication</div>
          </div>
          {/* round progress project management*/}
          <div className="flex gap-2 flex-col items-center justify-center about__content">
            <motion.div
              initial={{
                background: `conic-gradient(
            hsl(250, 69%, 61%)${0}deg,
            hsla(250, 69%, 61%, 0.40) ${0}deg
            )`,
              }}
              animate={{
                background: `conic-gradient(
            hsl(250, 69%, 61%)${projectManagement * 3.6}deg,
            hsla(250, 69%, 61%, 0.40) ${projectManagement * 3.6}deg
            )`,
              }}
              transition={{ duration: 1.5, ease: "easeIn" }}
              className="w-[45%]  aspect-square rounded-full relative shadow-sm"
            >
              <div className="flex items-center flex-col  justify-center w-[93%]  about__content  bg-containerColor dark:bg-darkContainerColor aspect-square rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <span className="text-base md:text-xs lg:text-base  font-semibold ">
                  {projectManagement}%
                </span>
              </div>
            </motion.div>
            <div className="">Management</div>
          </div>
          {/* round progress */}
          <div className="flex gap-2 flex-col items-center justify-center about__content">
            <motion.div
              initial={{
                background: `conic-gradient(
            hsl(250, 69%, 61%)${0}deg,
            hsla(250, 69%, 61%, 0.40) ${0}deg
            )`,
              }}
              animate={{
                background: `conic-gradient(
            hsl(250, 69%, 61%)${creativity * 3.6}deg,
            hsla(250, 69%, 61%, 0.40) ${creativity * 3.6}deg
            )`,
              }}
              transition={{ duration: 1.5, ease: "easeIn" }}
              className="w-[45%]  aspect-square rounded-full relative shadow-sm"
            >
              <div className="flex items-center flex-col  justify-center w-[93%]  about__content  bg-containerColor dark:bg-darkContainerColor aspect-square rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <span className="text-base md:text-xs lg:text-base  font-semibold ">
                  {creativity}%
                </span>
              </div>
            </motion.div>
            <div className="">Creativity</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
